import React from 'react'
import { getSHiftDisplayName } from '../../../utility/RolesUtility'
import { profileDto } from '../../../api/Dtos/profileDto'
interface infoData {
    submittedData:any
  }
const BasicEventInfo:React.FC<infoData>=({submittedData})=> {
  return (
    <div className='bg-white mt-3 p-5 px-8'>
        <h3 className='text-primary-color font-semibold text-2xl border-b pb-4 border-b-gray-200'>Basic Information</h3>
      <div>
      <div className='pb-3 pt-5'>
      <div className="flex gap-5 items-center">
                <img src={submittedData?.imageDto?.documentUrl || '/images/userImg.svg'} className="size-[80px] rounded-full" />
               <div className="">
                  <p className="font-bold text-[18px] text-gray-900 mb-0">
                    {submittedData?.name || 'NA'}
                  </p>
                  <p className="font-normal text-sm text-gray-600 pt-1">
                    {submittedData?.email || 'NA'}
                  </p>
                  </div>
              </div>
              <div className="font-Inter text-base pt-7">
          <p className="text-base font-semibold text-gray-900 pb-2 break-words">About Event Organiser
          </p>
          <div className="scroolCls">
          <p className="text-gray-800 break-words">
           {submittedData?.companyInfo || 'NA'}
          </p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4 font-Inter  mr-8 pb-5 pt-3">
        <div>
            <p className="text-sm font-normal text-gray-700 pb-1">
            Contact Person Name
            </p>
            <p className="font-semibold text-base text-gray-900">{submittedData?.contactPersonName || 'NA'}</p>
          </div>
          <div>
            <p className="text-sm font-normal text-gray-700 pb-1">
              Phone Number
            </p>
            <p className="font-semibold text-base text-gray-900">{submittedData?.phoneNo || 'NA'}</p>
          </div>
          
        </div>
        <div className="border-b-2 border-gray-200 font-Inter">
          <p className="text-sm font-normal text-gray-700 pb-1">Address</p>
          <p className="font-semibold text-base text-gray-900 pb-4">
          {
            [ submittedData?.streetAddress,
              submittedData?.apartment,
              submittedData?.mtCountryDto?.name,
              submittedData?.state,
              submittedData?.city,
              submittedData?.postalCode,].some(value => value?.toString().trim())
            ? [ submittedData?.streetAddress,
              submittedData?.apartment,
              submittedData?.mtCountryDto?.name,
              submittedData?.state,
              submittedData?.city,
              submittedData?.postalCode,]
                .filter(value => value?.toString().trim())
                .join(', ')
            : "NA"
           }
          </p>
        </div>
      </div>
      </div>
    </div>
  )
}
export default BasicEventInfo
